/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {
  ScrollView,
  Text,
  View,
  StyleSheet,
  Switch,
} from 'react-native';
import MapView, {Callout, Marker} from 'react-native-maps';
import {useRoute} from '@react-navigation/native';
import WorkOrderCostsTable from '../components/WorkOrderCostsTable';
import {Divider} from 'native-base';
import Container from '../../../components/Container';
import Navbar from '../../../components/Navbar';
import {Card} from 'react-native-paper';
import ZoomableImage from '../../../components/ZoomableImage';
import { WorkOrder } from '../../../@types/WorkOrder';

export default function WorkOrderDetails({navigation}) {
  const {params} = useRoute();
  const workOrder:WorkOrder = params?.workOrder;

  if (!workOrder) {
    return null;
  }

  return (
    <Container>
      <Navbar title="Work Order Details" navigation={navigation} />

      <ScrollView
        keyboardShouldPersistTaps="handled"
        style={{
          marginHorizontal: 8,
          paddingVertical: 16,
        }}>
        <Card
          style={{
            padding: 8,
            marginBottom: 32,
            paddingTop: 16,
          }}>
          <View style={styles.row}>
            <Text style={styles.onePickerLabel}>Status</Text>
            <Text style={styles.onePickerLabel}>{workOrder.status}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.onePickerLabel}>Type</Text>
            <Text style={styles.onePickerLabel}>{workOrder.type}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.onePickerLabel}>Priority</Text>
            <Text style={styles.onePickerLabel}>{workOrder.priority}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.switchLabel}>LocationIsAUnit</Text>
            <Switch
              // style={styles.switch}
              value={workOrder.locationIsAunit}
              disabled
            />
          </View>

          {workOrder.locationIsAunit && (
            <>
              <Text style={[styles.userNameLabel, {marginTop: 10}]}>Unit</Text>
              <Text style={[styles.userNameLabel, {paddingHorizontal: 10}]}>
                {workOrder.locationUnitDisplay}
              </Text>
            </>
          )}
          <Divider />

          <View style={{marginTop: 10}}>
            <Text style={styles.userNameLabel}>ShortLocation</Text>
            <Text style={[styles.userNameLabel, {paddingHorizontal: 10}]}>
              {workOrder.shortLocation}
            </Text>
          </View>
          <Divider />

          <View style={{marginTop: 10}}>
            <Text style={styles.userNameLabel}>Location</Text>
            <Text style={[styles.userNameLabel, {paddingHorizontal: 10}]}>
              {workOrder.location}
            </Text>
          </View>
          <Divider />
          <Text style={styles.userNameLabel}>Picture image</Text>
          <ZoomableImage
            title={workOrder.shortDescription}
            source={{
              uri: workOrder.pictureImage
                ? `data:image/jpeg;base64,${workOrder.pictureImage}`
                : 'https://nichemodels.co/wp-content/uploads/2019/03/user-dummy-pic.png',
            }}
            style={{
              height: 120,
              width: 120,
              borderRadius: 4,
            }}
          />
          <View style={{marginTop: 24}}>
            <Text style={styles.userNameLabel}>Short Description</Text>
            <Text style={[styles.userNameLabel, {paddingHorizontal: 10}]}>
              {workOrder.shortDescription}
            </Text>
          </View>

          <View style={{marginTop: 24}}>
            <Text style={styles.userNameLabel}>Description</Text>
            <Text style={[styles.userNameLabel, {paddingHorizontal: 10}]}>
              {workOrder.description}
            </Text>
          </View>
          <Divider />

          <>
            <View style={styles.row}>
              <Text style={styles.onePickerLabel}>Assigned to</Text>
              <Text style={[styles.userNameLabel, {marginBottom: 0}]}>
                {workOrder.assignedToName}
              </Text>
            </View>
          </>
          <Divider />

          <View style={styles.row}>
            <Text style={styles.switchLabel}>Paid In Full</Text>
            <Switch
              // style={styles.switch}
              value={workOrder.paidInFull}
              disabled
            />
          </View>

          <View style={{marginTop: 10}}>
            <Text style={styles.userNameLabel}>Amount paid</Text>
            <Text style={[styles.userNameLabel, {paddingHorizontal: 10}]}>
              {workOrder.amountPaid}
            </Text>
          </View>
          <Divider />

          <WorkOrderCostsTable
            workOrdersCosts={workOrder.workOrdersCosts}
            addWorkOrderCost={() => {}}
            editable={false}
          />

          <View style={{marginVertical: 12}}>
            <Text style={styles.textLabel}>Location</Text>
            <MapView
              zoomEnabled={false}
              minZoomLevel={17}
              style={styles.map}
              scrollEnabled={false}
              region={{
                latitude: workOrder.latitude,
                longitude: workOrder.longitude,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421,
              }}>
              <Marker
                coordinate={{
                  latitude: workOrder.latitude,
                  longitude: workOrder.longitude,
                }}></Marker>
            </MapView>
            <Text style={styles.detailsText}>{`Longitude : ${
              workOrder.longitude
            }`}</Text>
            <Text style={styles.detailsText}>{`Latitude : ${
              workOrder.latitude
            }`}</Text>
          </View>
        </Card>
      </ScrollView>
    </Container>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 8,
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
    alignItems: 'center',
  },
  onePickerLabel: {
    // color: TEXT_DEFAULT_COLOR,
    marginTop: 8,
    flex: 1,
    fontSize: 15,
  },
  userNameLabel: {
    // color: TEXT_DEFAULT_COLOR,
    marginBottom: 4,
    flex: 1,
    fontSize: 15,
  },
  userNameInput: {
    height: 40,
    // borderColor: TEXT_GRAY_COLOR,
    borderWidth: 1,
    borderRadius: 4,
    padding: 8,
    flex: 1,
    color: 'black',
    marginBottom: 16,
  },
  imageChooser: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
    marginBottom: 16,
  },
  imageContainer: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 8,
    width: 128,
    height: 96,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
  },
  map: {
    width: '100%',
    height: 276,
    marginTop: 8,
    marginBottom: 8,
  },
  locationLabel: {
    fontSize: 14,
    marginTop: 16,
    flex: 1,
  },
  switchLabel: {
    // color: TEXT_DEFAULT_COLOR,
    marginTop: 14,
    marginBottom: 4,
    flex: 1,
    fontSize: 15,
  },
  detailsText: {
    // color: TEXT_DEFAULT_COLOR,
    marginBottom: 4,
    flex: 1,
    fontSize: 15,
  },
  textLabel: {
    color: '#787688',
    marginBottom: 4,
    flex: 1,
    fontSize: 15,
  }
});
